import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSessionStore } from '@entities/session';
import { ROUTES } from '@shared/config/routes';

export function RequireAuth({ children }: { children: ReactNode }) {
  const status = useSessionStore((s) => s.status);
  const location = useLocation();

  if (status === 'unknown') {
    return <FullscreenSpinner />;
  }
  if (status === 'anonymous') {
    return <Navigate to={ROUTES.login} replace state={{ from: location }} />;
  }
  return <>{children}</>;
}

export function RequireAnonymous({ children }: { children: ReactNode }) {
  const status = useSessionStore((s) => s.status);
  if (status === 'unknown') return <FullscreenSpinner />;
  if (status === 'authenticated') return <Navigate to={ROUTES.root} replace />;
  return <>{children}</>;
}

function FullscreenSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-r-transparent" />
    </div>
  );
}
